// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image {
    display: none;
  }
  .form {
    width: 100%;
}
  
  /* Styles for screens larger than 600px */
  @media (min-width: 801px) {
    .image {
        width: 50%;
        display: block;
    }
    .form {
        width: 50%;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/login_style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;EACf;EACA;IACE,WAAW;AACf;;EAEE,yCAAyC;EACzC;IACE;QACI,UAAU;QACV,cAAc;IAClB;IACA;QACI,UAAU;IACd;EACF","sourcesContent":[".image {\n    display: none;\n  }\n  .form {\n    width: 100%;\n}\n  \n  /* Styles for screens larger than 600px */\n  @media (min-width: 801px) {\n    .image {\n        width: 50%;\n        display: block;\n    }\n    .form {\n        width: 50%;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
